/* eslint-disable arrow-body-style */
import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';
import CommonBubble from '@home/components/CommonBubble';
import { getLocale } from 'umi';
import { LANGUAGE_EN } from '@home/_config/config';
import OpinonsDownModal from '../OpinionsDownModal';
import { capitalize } from 'lodash-es';
import './index.scss';

interface IProps {
  className: string;
  style: React.CSSProperties;
  config?: any;
  filter: any;
  channelList: any;
}

export default function OpinionsReportFilterLeft(props: IProps) {
  const { className, style, config, channelList, filter } = props || {};
  const isEn = getLocale() === LANGUAGE_EN;
  const { downloadToolTipEn, downloadToolTipCn, emailToolTipEn, emailToolTipCn, downloadIcon = "download-icon", emailIcon = "email-icon" } = config || {};
  // 下载和邮件提示语
  const { downloadToolTip, emailToolTip } = useMemo(() => {
    return {
      downloadToolTip: isEn ? downloadToolTipEn : downloadToolTipCn,
      emailToolTip: isEn ? emailToolTipEn : emailToolTipCn,
    };
  }, [downloadToolTipCn, downloadToolTipEn, emailToolTipCn, emailToolTipEn, isEn]);

  const defaultChannelOpts = { value: 'all', text: 'All' };

  const [visibleDown, setVisibleDown] = useState(false);
  const [channelOpts, setChannelOpts] = useState([defaultChannelOpts]);


  // 获取channel选项
  const getChannelOptions = async () => {
    try {
      const newChannelList = channelList?.map((item: { channel: any; }) => {
        return {
          value: item.channel,
          text: capitalize(item.channel)
        };
      }) || [];
      setChannelOpts([defaultChannelOpts, ...newChannelList]);
    } catch (error) {
      console.log("★ ~ getChannelOptions error>>", error);
      setChannelOpts([defaultChannelOpts]);
    }
  };

  // 预加载弹窗数据
  useEffect(() => {
    if(!channelList?.length) return;
    getChannelOptions();
  }, [channelList]);

  return (
    <div className={classNames('dbh-studio-opinion-filter-report-left', className)} style={style}>
      <div className="dbh-studio-opinion-filter-report-left-download" >
        <CommonBubble
          dark
          escapeWithReference
          flipped={false}
          content={downloadToolTip}
        >
          <i onClick={() => setVisibleDown(true)}>
            <SvgIcon className="dbh-studio-opinion-filter-report-left-download-icon" type={downloadIcon} />
          </i>
        </CommonBubble>
      </div>
      <div className="dbh-studio-opinion-filter-report-left-email">
        <CommonBubble
          dark
          escapeWithReference
          flipped={false}
          content={emailToolTip}
        >
          <i>
            <SvgIcon className="dbh-studio-opinion-filter-report-left-email-icon" type={emailIcon} />
          </i>
        </CommonBubble>
      </div>
      <OpinonsDownModal filter={filter} defaultChannelValue='all' channelList={channelOpts} visible={visibleDown} setVisible={setVisibleDown} />
    </div>
  );
}
